var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90039 1.79941C6.90039 1.30236 6.49745 0.899414 6.00039 0.899414C5.50333 0.899414 5.10039 1.30236 5.10039 1.79941V5.09941H1.80039C1.30333 5.09941 0.900391 5.50236 0.900391 5.99941C0.900391 6.49647 1.30333 6.89941 1.80039 6.89941H5.10039V10.1994C5.10039 10.6965 5.50333 11.0994 6.00039 11.0994C6.49745 11.0994 6.90039 10.6965 6.90039 10.1994V6.89941H10.2004C10.6974 6.89941 11.1004 6.49647 11.1004 5.99941C11.1004 5.50236 10.6974 5.09941 10.2004 5.09941H6.90039V1.79941Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepPlus);
export default __webpack_public_path__ + "static/media/step-plus.15df457189ba59a7f03b49ddcb0e0eb2.svg";
export { ForwardRef as ReactComponent };